import { ImageService } from './../../shared/tools/social-media-buttons/image.service';
import { AfterViewInit, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import {
  FullMenuSection,
  Package,
  Page,
  StandardPageDetails,
  SubPackage
} from '../../shared/tools/services/kla.data.models';
import { ImgUrlCreationService } from '../../shared/services/img-url-creation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../shared/services/data.service';
import { TitleLineConfigurations } from '../../shared/tools/title/title.configurations';
import { HomePanelConfigurations } from '../../shared/tools/home-panel/home-panel-configurations';
import { CommonModule, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { StripSpecialCharsPipe } from '../../shared/tools/strip-special-chars/strip-special-chars.pipe';
import { Meta } from '@angular/platform-browser';
import { KlaHttpService } from '../../shared/tools/services/kla.http.service';
import { StripHtmlPipe } from '../../shared/pipes/strip-html.pipe';
import { Subscription } from 'rxjs';
import { TitleComponent } from 'app/shared/tools/title/title.component';
import { SimpleImageComponent } from 'app/shared/tools/simple-image/simple-image.component';
import { CarouselComponent } from 'app/shared/tools/carousel/carousel.component';
import { OutgrowComponent } from 'app/shared/tools/outgrow/outgrow.component';
import { VideoComponent } from 'app/shared/tools/video/video.component';
import { LineGraphComponent } from 'app/shared/tools/line-graph/line-graph.component';
import { BarGraphComponent } from 'app/shared/tools/bar-graph/bar-graph.component';
import { ComplexBarGraphComponent } from 'app/shared/tools/complex-bar-graph/complex-bar-graph.component';
import { ColorListComponent } from 'app/shared/tools/color-list/color-list.component';
import { SingleDonutWithImageComponent } from 'app/shared/tools/single-donut-with-image/single-donut-with-image.component';
import { ThriveSignUpFormComponent } from 'app/shared/tools/thrive-sign-up-form/thrive-sign-up-form.component';
import { PictographComponent } from 'app/shared/tools/pictograph/pictograph.component';
import { IndicatorMultipleRingsComponent } from 'app/shared/tools/indicator-multiple-rings/indicator-multiple-rings.component';
import { RingGraphComponent } from 'app/shared/tools/ring-graph/ring-graph.component';
import { IndicatorBubbleGraphComponent } from 'app/shared/tools/indicator-bubble-graph/indicator-bubble-graph.component';
import { SurveyComponent } from 'app/shared/tools/survey/survey.component';
import { QuestionComponent } from 'app/shared/tools/question/question.component';
import { ProgressbarWithCircleChartComponent } from 'app/shared/tools/progressbar-with-circle-chart/progressbar-with-circle-chart.component';
import { MultiImageComponent } from 'app/shared/tools/multi-image/multi-image.component';
import { ScriptComponent } from 'app/shared/tools/script/script.component';
import { ActionPlanTaxanomyComponent } from 'app/shared/tools/action-plan-taxanomy/action-plan-taxanomy.component';
import { NewActionTaxonomyComponent } from 'app/shared/tools/new-action-taxonomy/new-action-taxonomy.component';
import { FilterVisiblePipe } from 'app/shared/tools/filter-visible/filter-visible';
import { TileCollectionComponent } from 'app/shared/tools/tile-collection/tile-collection.component';
import { PostGridComponent } from 'app/widgets/grid/postGrid/postGrid.component';
import { IndicatorBasicComponent } from 'app/shared/tools/indicator-basic/indicator-basic.component'
import { IntroComponent } from 'app/shared/tools/intro/intro.component';
import { CircleLineGraphComponent} from 'app/shared/tools/circle-line-graph/circle-line-graph.component'


@Component({
  selector: 'app-custom-page',
  templateUrl: './custom-page.component.html',
  styleUrls: ['./custom-page.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent, SimpleImageComponent, CarouselComponent, OutgrowComponent, VideoComponent, LineGraphComponent,
    BarGraphComponent, ComplexBarGraphComponent, ColorListComponent, SingleDonutWithImageComponent, ThriveSignUpFormComponent, PictographComponent,
    IndicatorMultipleRingsComponent, RingGraphComponent, IndicatorBubbleGraphComponent, SurveyComponent, QuestionComponent,
    ProgressbarWithCircleChartComponent, MultiImageComponent, ScriptComponent, ActionPlanTaxanomyComponent, NewActionTaxonomyComponent, FilterVisiblePipe, 
    TileCollectionComponent, PostGridComponent, IndicatorBasicComponent, IntroComponent,CircleLineGraphComponent ]
})
export class CustomPageComponent implements OnInit, AfterViewInit, OnDestroy {

  public data: Array<FullMenuSection>;
  @Input() public standardData: Page<any>;
  @Input() public dashboardData: Page<any>;

  currentPage;
  fragment;

  public imgUrl;
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private viewportScroller: ViewportScroller,
    private metaService: Meta,
    private httpService: KlaHttpService,
    private imageService: ImageService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
  }

  ngOnInit() {
    this.fragment = this.route.snapshot.fragment;
    this.standardData = this.prepareStandardData();
    this.createMetaTags();
    this.route.params.subscribe(params => {
      this.standardData = this.prepareStandardData();
      this.createMetaTags();
    });
  }

  ngAfterViewInit() {
    if (this.fragment) {
      this.scrollToElement(this.fragment);
    }
    this.subscribeToFragment();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  get mainSiteColor() {
    return this.standardData.details.packages[0].packageDetails.color ? this.standardData.details.packages[0].packageDetails.color : '';
  }

  smoothScroll() {
    document.getElementsByTagName('html')[0].setAttribute('style', 'scroll-behavior: smooth;');
  }

  prepareStandardData() {
    const routerUrl = this.router.url.replace('/', '').replace('#' + this.route.snapshot.fragment, '').split('?')[0];
    const url = !DataService.isLivePreview ? routerUrl : this.route.snapshot.paramMap.get('page');
    this.currentPage = url;
    const page: Page<StandardPageDetails> = DataService.getPage('/' + url);
    this.imgUrl = (page?.image) ? ImgUrlCreationService.createImgUrl(page.image.id, 'w1960') : '/assets/big-placeholder.jpg';
    if (page?.details.packages) {
      page.details.packages.forEach((pack: Package, packageIndex: number) => {
        pack.intro = this.generateHomePanelConfigurations(pack, page.url, packageIndex);
        pack.subPackages.forEach((subPackage: SubPackage, subPackageIndex: number) => {
          subPackage.line = this.generateLineConfig(pack, packageIndex, subPackageIndex);
        });
      });
    }
    const element = document.getElementById('content');
    setTimeout(() => {
      if (!this.fragment || this.fragment == null || this.fragment == undefined) {
        if (element) {
          element.scrollIntoView({
            block: 'start'
          });
        }
      }
      this.subscribeToFragment();

    }, 1000)
    return page;
  }

  generateLineConfig(selectedPackage: Package, packageIndex: number, subPackageIndex: number): TitleLineConfigurations {
    return <TitleLineConfigurations>{
      menuIndex: packageIndex,
      sectionIndex: subPackageIndex,
      numberOfSections: selectedPackage && selectedPackage.subPackages ? selectedPackage.subPackages.length : 0,
      sectionColor: selectedPackage.packageDetails.color
    };
  }

  generateHomePanelConfigurations(packageName: Package, route: string, packageIndex: number): HomePanelConfigurations {
    return {
      details: packageName.packageDetails,
      links: packageName.subPackages.map((subPackage: SubPackage, index: number) => {
        const link = subPackage.link;
        link.routePath = route;
        link.routeFragment = subPackage.fragment;
        return link;
      }),
      newsId: packageName.newsId,
    };
  }

  subscribeToFragment() {
    const sub = this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
      if (fragment) {
        this.scrollToElement(fragment);
      }
    });
    this.subscriptions.push(sub);
  }

  scrollToElement(fragment, attempt = 0) {
    if (isPlatformBrowser(this.platformId)) {
      let el = document.getElementsByClassName('component-fragment-' + fragment)[0];
      if (!el) {
        el = document.getElementById(fragment);
      }
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({
            block: 'center',
            behavior: 'smooth',
            inline: 'center'
          });
        }, 300);
      } else {
        if (attempt < 3) {
          this.scrollToElement(fragment, ++attempt);
        }
      }
    }
  }


  getComponentFragment(component) {
    let fragment = this.findVal(component, 'title') || this.findVal(component, 'header') || this.findVal(component, 'question') || 'component';
    if (typeof fragment === 'object') {
      fragment = this.getComponentFragment(fragment);
    }
    return StripSpecialCharsPipe.strip(fragment);
  }

  findVal(object, key) {
    let value;
    Object.keys(object).some(k => {
      if (k === key) {
        value = object[k];
        return true;
      }
      if (object[k] && typeof object[k] === 'object') {
        value = this.findVal(object[k], key);
        return value !== undefined;
      }
    });
    return value;
  }

  private getLogoPath() {
    const imageConfig = {
      id: DataService.LOGO_DATA.image,
      width: 500,
      height: +DataService.LOGO_DATA.height,
      cropConfig: DataService.LOGO_DATA.crop_config
    };
    if (imageConfig.cropConfig && (imageConfig.width || imageConfig.height)) {
      this.imageService.mainImgPath.next(this.httpService.getCroppedImagePath(imageConfig));
      return this.httpService.getCroppedImagePath(imageConfig);
    } else {
      return this.httpService.getImagePath(imageConfig.id, imageConfig.width);
    }

  }

  private createMetaTags() {
    this.clearMetaTags();

    this.metaService.addTags([
      { property: 'og:site_name', content: DataService.getData().name },
      { property: 'og:title', content: this.standardData?.name },
      { property: 'og:locale', content: 'en_US' },
      { property: 'og:image', content: this.getLogoPath() },
      { property: 'og:image:width', content: 500 },
      { property: 'og:image:height', content: DataService.LOGO_DATA.height },
      { property: 'og:image:alt', content: `${DataService.getData().name} Logo` },
      { property: 'og:type', content: 'website' },
      { property: 'og:description', content: StripHtmlPipe.strip(this.standardData?.details.description) },
      { name: 'twitter:image', content: this.getLogoPath() },
      { name: 'twitter:image:alt', content: `${DataService.getData().name} Logo` },
    ]);
  }

  private clearMetaTags() {
    const metaTags = document.getElementsByTagName('meta');
    const metaNamesToRemove = [
      'og:site_name',
      'og:title',
      'og:image',
      'og:image:width',
      'og:image:height',
      'og:image:alt',
      'og:type',
      'og:description',
      'og:locale',
      'twitter:image',
      'twitter:image:alt'
    ];
  
    Array.from(metaTags).forEach(meta => {
      const name = meta.getAttribute('name') || meta.getAttribute('property');
      if (name && metaNamesToRemove.includes(name)) {
        meta.parentNode?.removeChild(meta); // Remove the meta tag
      }
    });
  }

}
